(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-summary"] && !Shopify.designMode) return;
  try {
    
 $(document).ready(function() {
  setTimeout(function() {  
     $('.vertical-slider').hide();
    var $slider = $('.vertical-slider');

    if ($slider.length > 0) {
      
      if ($slider.children().length > 1) {
        console.log("Initializing slick slider...");
        
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        });
         $('.vertical-slider').fadeIn();
      } else {
        console.log("Slider does not have more than one child.");
      }
    } 
  }, 100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["core-team"] && !Shopify.designMode) return;
  try {
     
$(document).ready(function() {
  function wrapElements(groupClass) {
      var $groupElements = $('.' + groupClass);
      var $wrapper = $('<div class="wrapper ' + groupClass + '-wrapper"></div>');
      
      $groupElements.each(function() {
        $(this).appendTo($wrapper);
      });
    
      $wrapper.appendTo('.core-team-slider');
    }
 function initializeSliderIfNecessary(wrapperClass) {
      var $wrapper = $('.' + wrapperClass);
    
      if ($wrapper.children().length > 3) {
        $wrapper.removeClass('not-slider');
        $wrapper.slick({
          dots: false,
          infinite: false,
          arrows: false,
          speed: 600,
          slidesToShow: 3.5,
          autoplay: false,
          autoplaySpeed: 2000,
          easing: 'ease-in-out',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1
              }
            }
          ]
        });
      } else {
        $wrapper.addClass('not-slider');
      }
    }
    wrapElements('topic-block-topic_1');
    wrapElements('topic-block-topic_2');
    wrapElements('topic-block-topic_3');
   initializeSliderIfNecessary('topic-block-topic_1-wrapper');
    initializeSliderIfNecessary('topic-block-topic_2-wrapper');
    initializeSliderIfNecessary('topic-block-topic_3-wrapper');
  
  $('.core-team-slider .staff').hide();
  var initialTopic = $('.topic.selected').data('topic');
  $('.topic-block-' + initialTopic).show();
  $('.core-team-slider .wrapper').addClass('not-new');
   $('.topic-block-' + initialTopic + '-wrapper').addClass('neww');
  $('.topic').on('click', function() {
    var topic = $(this).data('topic');
    var title = $(this).data('title');
    const topicc = $(this);
      const container = document.querySelector('.scrollable');
      if (window.innerWidth <= 768 && container) {
          // Get raw DOM elements
          const containerRect = container.getBoundingClientRect();
          const tabRect = topicc[0].getBoundingClientRect(); // `topicc[0]` gets the raw DOM element
        
          // Calculate the position to scroll to
          const offset = tabRect.left - containerRect.left; // Position of the tab within the container
          const containerScrollLeft = container.scrollLeft;
          const containerWidth = container.clientWidth;
          const tabWidth = topicc[0].clientWidth;
        
          // Calculate the scroll position to center the tab
          let scrollLeft = containerScrollLeft + offset - (containerWidth / 2) + (tabWidth / 2);
        
          // Clamp scrollLeft between 0 and max scrollable width
          const maxScrollLeft = container.scrollWidth - container.clientWidth;
          scrollLeft = Math.max(0, Math.min(scrollLeft, maxScrollLeft));
        
          // Smoothly scroll the container
          container.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }


    $('.core-team-slider .staff').hide();

    $('.topic-block-' + topic).show();
   $('.core-team-slider .wrapper').addClass('not-new').removeClass('neww');
    $('.topic-block-' + topic + '-wrapper').removeClass('not-new').addClass('neww');
    
    $('.topic').removeClass('selected');
    $(this).addClass('selected');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if(this.searchModal) {
        this.searchModal.close(false);
      }   
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
